const get_time = () => {
	return (new Date()).getTime();
}

class StopWatch {
	constructor() {
		this.t0 = undefined;
	}

	start() {
		this.t0 = get_time();
	}

	stop() {
		if (this.t0 === undefined) return undefined;
		const dt = get_time() - this.t0;
		this.t0 = undefined;
		return dt;
	}

	is_running() {
		return this.t0 !== undefined;
	}
}

class DelayedCallback {
	constructor() {
		this.cancel();
	}

	start(delay_ms, callback) {
		this.cancel();
		this.timeout = setTimeout(() => {
			this.fired = true;
			callback();
		}, delay_ms);
	}

	cancel() {
		if (this.timeout !== undefined) clearTimeout(this.timeout);
		this.timeout = undefined;
		this.fired = false;
	}

	did_fire() {
		return this.fired;
	}
}

export {
	get_time,
	StopWatch,
	DelayedCallback
}



// WEBPACK FOOTER //
// ./src/Time.js